import { StandardEvents } from '@shopify/events';
import { ThemeEvents } from '@theme/events';
import { bundlePrice, bundlePhotos, bundleNames, bundleQualifier, bundleProperties } from './mug-bundle-utils.js';

const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(cents/100);
class ArtworkServices extends HTMLElement {
 connectedCallback() {
  this.abort?.abort(); this.abort=new AbortController(); const {signal}=this.abort;
  this.services=JSON.parse(this.querySelector('[data-service-variants]').textContent);
  this.product=JSON.parse(this.querySelector('[data-service-product]').textContent);
  this.form=this.closest('form'); this.section=this.closest('.shopify-section');
  this.section.addEventListener('change',()=>this.sync(),{signal});
  this.section.addEventListener('input',()=>this.sync(),{signal});
  this.section.addEventListener(ThemeEvents.quantitySelectorUpdate,()=>this.sync(),{signal});
  this.section.addEventListener(StandardEvents.productSelect,event=>event.promise?.then(()=>requestAnimationFrame(()=>this.sync())),{signal});
  this.observer=new MutationObserver(()=>this.sync());
  const variant=this.form.querySelector('[name="id"]'); if(variant)this.observer.observe(variant,{attributes:true,attributeFilter:['value']});
  this.sync();
 }
 selection() {
  if(this.section.querySelector('la-holiday-mug input[value="design"]:checked'))return [];
  const selected=[];
  const tier=this.section.querySelector('[data-background-tier]:checked')?.dataset.backgroundTier;
  if(['portrait','digital-portrait'].includes(this.dataset.mode) && ['premium','limited'].includes(tier))selected.push(tier);
  for(const checkbox of this.querySelectorAll('[data-service]:checked')) {if(checkbox.dataset.service==='digital'&&this.section.querySelector('portrait-inline-digital')?.selected)continue;selected.push(checkbox.dataset.service);}
  return selected;
 }
 sync() {
  this.hidden=Boolean(this.section.querySelector('la-holiday-mug input[value="design"]:checked'));
  this.style.display=this.hidden?'none':'';
  if(this.hidden){for(const checkbox of this.querySelectorAll('[data-service]:checked'))checkbox.checked=false;return;}
  const digital=this.section.querySelector('portrait-inline-digital');
  const variant=digital?.selected?digital.variant:this.product.variants.find(v=>String(v.id)===this.form.querySelector('[name="id"]')?.value);
  if(!variant){const node=this.querySelector('[data-service-subtotal]');if(node)node.textContent='Choose an available configuration';return;}
  const quantity=Math.max(1,Number(this.form.querySelector('[name="quantity"]')?.value)||1);
  const total=variant.price*quantity+this.selection().reduce((sum,key)=>sum+this.services[key].price,0);
  const node=this.querySelector('[data-service-subtotal]'); if(node.textContent!==money(total))node.textContent=money(total);
 }
 payload(data) {
  const digital=this.section.querySelector('portrait-inline-digital');
  if(digital?.selected)return digital.payload(data,this);
  const props={}; for(const [name,value] of data) { const match=name.match(/^properties\[(.*)\]$/); if(match && typeof value==='string')props[match[1]]=value; }
  const design=crypto.randomUUID(); props._artwork_design=design;
  const parent={id:Number(data.get('id')),quantity:Number(data.get('quantity'))||1,properties:props};
  const items=[parent];
  for(const key of this.selection()) {
   const service=this.services[key];
   items.push({id:service.id,parent_id:parent.id,quantity:1,properties:{_artwork_design:design,_artwork_service:key,'For artwork':this.dataset.productTitle,'Service basis':'Once per customized order line',...(props['Pet Names']?{'Pet Names':props['Pet Names']}:{})}});
  }
  return {items,sections:data.getAll('sections').join(','),sections_url:location.pathname};
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
}
if(!customElements.get('artwork-services'))customElements.define('artwork-services',ArtworkServices);

class PortraitMugOffer extends HTMLElement {
 connectedCallback() {
  if(this.dataset.offerEnabled!=='true')return;
  this.abort?.abort();this.abort=new AbortController();const {signal}=this.abort;
  this.product=JSON.parse(this.querySelector('[data-offer-mug]').textContent);
  this.eligibleIds=JSON.parse(this.querySelector('[data-bundle-eligible]').textContent);
  this.dialog=this.querySelector('dialog');
  document.addEventListener('click',event=>{
   const checkout=event.target.closest('[name="checkout"],a[href="/checkout"],a[href^="/checkout?"]');
   if(!checkout || event.defaultPrevented)return;
   event.preventDefault();this.open().catch(()=>{location.href='/checkout';});
  },{signal});
  this.querySelector('[data-offer-skip]').addEventListener('click',()=>this.checkout(),{signal});
  this.querySelector('[data-offer-close]').addEventListener('click',()=>this.dialog.close(),{signal});
  this.querySelector('[data-offer-add]').addEventListener('click',()=>this.add(),{signal});
  this.querySelector('[data-offer-size]').addEventListener('change',()=>this.update(),{signal});
  this.querySelector('[data-offer-design]').addEventListener('change',()=>this.update(),{signal});
 }
 async open() {
  if(this.busy)return; this.busy=true;
  try {
   const cart=await fetch(`${window.Shopify.routes.root}cart.js`).then(r=>r.json());
   const qualifiers=cart.items.filter(item=>bundleQualifier(item,this.product.id,this.eligibleIds));
   this.parents=qualifiers.filter(item=>bundlePhotos(item).length);
   const portraitQuantity=qualifiers.reduce((sum,item)=>sum+item.quantity,0);
   const mugQuantity=cart.items.filter(item=>item.product_id===this.product.id).reduce((sum,item)=>sum+item.quantity,0);
   if(mugQuantity>=portraitQuantity)return this.checkout(false);
   this.signature=qualifiers.map(i=>`${i.key}:${i.quantity}`).sort().join('|');
   if(!qualifiers.length || !this.product?.variants?.some(v=>v.available) || sessionStorage.getItem('la-mug-offer:'+this.signature))return this.checkout(false);
   this.querySelector('[data-offer-personalization]').hidden=!this.parents.length;
   this.querySelector('[data-offer-upload]').hidden=Boolean(this.parents.length);
   this.querySelector('[data-offer-add]').disabled=!this.parents.length;
   const select=this.querySelector('[data-offer-design]');select.replaceChildren();
   this.parents.forEach((item,index)=>{const option=new Option(`${item.product_title} — ${item.properties?.['Pet Names']||item.properties?.['Pet name(s)']||'Design '+(index+1)}`,String(index));select.add(option);});
   const size=this.querySelector('[data-offer-size]');size.replaceChildren();
   for(const variant of this.product.variants.filter(v=>v.available))size.add(new Option(variant.title,String(variant.id)));
   this.update();this.dialog.showModal();
  }finally{this.busy=false;}
 }
 update(){
  const variant=this.product.variants.find(v=>String(v.id)===this.querySelector('[data-offer-size]').value);if(!variant)return;
  this.querySelector('[data-offer-regular]').textContent=money(variant.price);
  this.querySelector('[data-offer-price]').textContent=money(bundlePrice(variant.price));
  const item=this.parents[Number(this.querySelector('[data-offer-design]').value)||0];
  if(!item)return;
  if(this.namesSourceKey!==item.key){this.querySelector('[data-offer-names]').value=bundleNames(item).join(', ');this.namesSourceKey=item.key;}
  const photo=bundlePhotos(item)[0];
  const thumbnail=this.querySelector('[data-offer-photo]');thumbnail.hidden=!photo; if(photo)thumbnail.src=photo[1];
 }
 checkout(mark=true){if(mark&&this.signature)sessionStorage.setItem('la-mug-offer:'+this.signature,'seen');location.href=`${window.Shopify.routes.root}checkout`;}
 async add(){
  if(this.adding)return;this.adding=true;const button=this.querySelector('[data-offer-add]');button.disabled=true;button.setAttribute('aria-busy','true');
  try{
   const parent=this.parents[Number(this.querySelector('[data-offer-design]').value)||0];
   if(!parent)throw Error('Add your completed pet photo on the personalized mug page first.');
   const props=bundleProperties(parent,{names:this.querySelector('[data-offer-names]').value,include:this.querySelector('[data-offer-name]').value==='include'});
   const response=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(this.querySelector('[data-offer-size]').value),quantity:1,properties:props}]})});
   const result=await response.json();if(!response.ok)throw Error(result.description||'The mug could not be added.');
   sessionStorage.setItem('la-mug-offer:'+this.signature,'added');location.href=`${window.Shopify.routes.root}cart`;
  }catch(error){this.querySelector('[data-offer-error]').textContent=error.message;}finally{this.adding=false;button.disabled=false;button.removeAttribute('aria-busy');}
 }
 disconnectedCallback(){this.abort?.abort();}
}
if(!customElements.get('portrait-mug-offer'))customElements.define('portrait-mug-offer',PortraitMugOffer);

